"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var apiGroupSelectors = _interopRequireWildcard(require("../../../store/selectors"));
var _UnderlyingAPITermsList = _interopRequireDefault(require("./UnderlyingAPITermsList"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset,
    apiGroupInstanceId = _ref.apiGroupInstanceId;
  var underlyingAPIsTerms = apiGroupSelectors.instanceUnderlyingTerms(state, {
    groupId: asset.groupId,
    assetId: asset.assetId,
    versionGroup: asset.versionGroup,
    apiGroupInstanceId: apiGroupInstanceId
  });
  return {
    underlyingAPIsTerms: underlyingAPIsTerms
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(_UnderlyingAPITermsList.default);
//# sourceMappingURL=UnderlyingAPITermsList.container.js.map